module.exports = __webpack_public_path__ + "a3d5f4153f3ea10f47e491792e98cc1f.svg";